// Tour options =============================================================
import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const tour: SugarElementInfo = { name: "tour", availableChildren: { type: AvailableChildrenType.Any } };
